import MenuGroup from "@/views/admin/managementmenu/MenuGroup";

export default {
  path: "menus/menu-group",
  name: "menuGroup",
  component: MenuGroup,
  meta: {
    requiresAuth: true
  }
};
